export enum PaymentCardType {
  MASTER_CARD = 'mc',
  VISA = 'visa',
  SEPA = 'sepadirectdebit',
  UNKNOWN = 'n/a',
}
